import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommentState } from './comment.state';

const getFeatureState = createFeatureSelector<CommentState>('commentState');

export const getEditingComment = createSelector(
  getFeatureState,
  (state: CommentState) => state.editingComment
);
